import React, { useContext } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { GovernmentDataCard } from '~/components/Map/GovernmentDataCard';
import { UserReportedDataCard } from '~/components/Map/UserReportedDataCard';
import { useCovidOutbreakGovernmentData } from '~/state/hooks/useCovidOutbreakGovernmentData';
import { useUserReportedVirusOutbreakData } from '~/state/hooks/useUserReportedVirusOutbreakData';
import { CountryContext } from '~/context/i18n';
import * as Styled from './styles';

export const MapFilters: React.FC = () => {
  const {
    isLoading: isUserReportedDataLoading,
    symptomCounts,
  } = useUserReportedVirusOutbreakData();
  const {
    isLoading: isGovernmentDataLoading,
  } = useCovidOutbreakGovernmentData();
  const { country } = useContext(CountryContext);
  const countryCode = country.code.toLowerCase();
  const countriesWithoutGovernmentData = ['ca', 'mx'];
  const showGovernmentDataCard = !countriesWithoutGovernmentData.includes(
    countryCode
  );

  return (
    <Styled.Controls $showGovernmentDataCard={showGovernmentDataCard}>
      <Styled.ControlContainer>
        {isUserReportedDataLoading ? (
          <CircularProgress size={20} />
        ) : (
          <UserReportedDataCard symptomCounts={symptomCounts} />
        )}
      </Styled.ControlContainer>

      {showGovernmentDataCard && (
        <Styled.ControlContainer>
          {isGovernmentDataLoading ? (
            <CircularProgress size={20} />
          ) : (
            <GovernmentDataCard />
          )}
        </Styled.ControlContainer>
      )}
    </Styled.Controls>
  );
};
